import store from '@/store';

export default async (to) => {
    const slug = _.last(_.split(to.path, '/'));

    await store.dispatch('page/FETCH_CURRENT_PAGE', slug);
};
